import React, { memo } from "react";
// import { MarkerClusterer } from "react-google-maps/lib/components/addons/MarkerClusterer";
import { MarkerClustererF } from "@react-google-maps/api";
import DisplayMarkerWithLabel from "./DisplayMarkerWithLabel";

const DisplayMarkerCluster = props => {
  const { locations, showMarkerLabel } = props;

  if (!locations || !locations.length) {
    console.log("No valid locations for clustering");
    return null;
  }

  const selectMarker = (location) => {
    props.selectMarker(location);
  };

  const selectCluster = (cluster) => {
    props.selectCluster(cluster);
  };

  return (
    <>
      <MarkerClustererF
        averageCenter
        enableRetinaIcons
        onClick={selectCluster}
        zoomOnClick={true}
      >
        {(clusterer) => {
          return (
            locations &&
            locations?.map((location, i) => (
              <DisplayMarkerWithLabel
                key={i}
                locationCount={locations.length}
                location={location}
                selectMarker={selectMarker}
                showMarkerLabel={showMarkerLabel}
                clusterer={clusterer}
              />
            ))
          );
        }}
      </MarkerClustererF>
    </>
  );
};

export default memo(DisplayMarkerCluster);